import React from 'react';
import './StorySection.css';

export default function StorySection() {
  return (
    <section className="section story-section" id="story">
      <div className="story-split">
        <div className="story-media" aria-hidden="true" />
        <div className="story-pane">
          <div className="container">
            <div className="story-content">
              <h3 className="story-kicker">Sweet Justice</h3>
              <div className="story-est">EST. 2025</div>
              <p className="story-text">
                At GOLDLAW, we’re serving up justice one scoop at a time! Our Sweet Justice Ice Cream Truck is our
                rolling celebration of community goodwill, bringing smiles and delicious delights to Palm Beach County.
                For nearly 25 years, our “GOLD STANDARD” initiative has been all about supporting local charities and
                service organizations with a generous side of sweetness.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
